var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import { Button, Divider, Paper, TextField } from '@mui/material';
var PaperComponent = function (_a) {
    var children = _a.children, selectAll = _a.selectAll, onSearch = _a.onSearch, clearSelection = _a.clearSelection, toggleDropDownView = _a.toggleDropDownView, initialSeachQuery = _a.initialSeachQuery, selectedCount = _a.selectedCount, hideSearchOption = _a.hideSearchOption, rest = __rest(_a, ["children", "selectAll", "onSearch", "clearSelection", "toggleDropDownView", "initialSeachQuery", "selectedCount", "hideSearchOption"]);
    var _b = __read(useState(initialSeachQuery), 2), searchQuery = _b[0], setSearchQuery = _b[1];
    var _c = __read(useState('options'), 2), dropdownViewMode = _c[0], setDropdownViewMode = _c[1];
    var inputRef = useRef(null);
    useEffect(function () {
        if (inputRef.current) {
            inputRef.current.click();
        }
    }, []);
    var handleChange = function (event) {
        setSearchQuery(event.target.value);
        onSearch(event.target.value);
    };
    return (React.createElement(Paper, __assign({}, rest),
        !hideSearchOption && (React.createElement("div", { className: "lfc-my-2 lfc-w-full lfc-flex lfc-items-center lfc-justify-center " },
            React.createElement(TextField, { value: searchQuery, onChange: handleChange, InputProps: { ref: inputRef }, className: "lfc-w-[90%]", size: "small", placeholder: "Search by option" }))),
        React.createElement("div", { className: "lfc-flex lfc-items-center lfc-justify-between lfc-h-full ".concat(hideSearchOption ? 'lfc-p-2' : '') },
            React.createElement(Button, { size: "small", onClick: function () {
                    setDropdownViewMode(toggleDropDownView());
                } },
                dropdownViewMode === 'options' ? 'Selected' : 'View All Options',
                " (",
                selectedCount,
                ")"),
            React.createElement("div", { className: "lfc-flex lfc-items-center" },
                React.createElement(Button, { size: "small", onClick: selectAll }, "Select All"),
                React.createElement(Divider, { orientation: "vertical", className: "lfc-h-4" }),
                React.createElement(Button, { size: "small", onClick: clearSelection }, "Clear Selection"))),
        children));
};
export default PaperComponent;
//# sourceMappingURL=PaperComponent.js.map